<template>
    <DefaultLayout :title="modelNamePlural">

        <template #title>{{ modelNamePlural }}</template>
        <template #titleNav>
            <CreateNewButton :href="createRoute" v-if="createRoute" />
        </template>

        <template #default>

            <div class="py-6">
                <div class="mx-auto px-4 sm:px-6 md:px-8">
                    <slot></slot>
                </div>
            </div>

        </template>

    </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import CreateNewButton from "@/Components/CreateNewButton";

export default {
    components: {CreateNewButton, DefaultLayout},
    props: {
        createRoute: String,
        modelNamePlural: String,
    },
}
</script>
